import { Drill } from 'config/commonTypes';
import React from 'react';

interface DrillProgressType {
drill: Drill,
editable?:boolean,
isMobile?:boolean
}

const DrillProgress = ({drill, editable, isMobile}:DrillProgressType) => {
  return (<>
    <div style={{textAlign: 'left', verticalAlign: 'middle', display: 'inline-block', textTransform: 'uppercase'}}>
      {!drill.state ? <i style={{color: '#535353', fontWeight: 'lighter'}}>Unstarted</i> : drill.state === 'FINISH' ?
        <div className='complete-color'><strong className="mdi mdi-check-circle"/>{'   Complete'}</div> :
        editable? isMobile ?
        <div className="saving" style={{color: '#00658B'}}>
          <label style={{paddingLeft: '10px'}}>IN
          PROGRESS</label></div>:
          <div className="saving" style={{color: '#00658B'}}>
          <span>.</span><span>.</span><span>.</span><span>.</span><span>.</span>
          <label style={{paddingLeft: '10px'}}>IN
          PROGRESS</label></div>:
          <div className="saving" style={{color: '#00658B'}}>
          <span>.</span><span>.</span><span>.</span><span>.</span><span>.</span>
          <label style={{paddingLeft: '10px'}}>IN
          PROGRESS</label></div>}
    </div>
  </>);
};

export default DrillProgress;